import React, { Component } from "react";
import {
  getDT,
  getWidgetTypes,
  updateForm,
  saveFormWidget,
  getFormWidgets,
  getQuestionTypes,
  removeWidget,
} from "../../services/formService";
import { Modal } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import { toaster } from "../../config";
import WQualtrics from "./Editor/Widget_Qualtrics";
import WQuestionAnswer from "./Editor/Widget_QA";
import WIdentifier from './Editor/Widget_Identifier';
import WTab from "./Editor/Widget_Tab";
import WDisplayEditInfo from './Editor/Widget_DisplayEditInfo';
import Preview from "./Editor/Preview";
import { Markup } from "interweave";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { updateQuestionOrder } from "./../../services/formService";
import * as Icon from "react-feather";
import CustomLoader from "../common/Loader";
import { WidgetTypes } from "../../constants/QuestionTypes";
import WDataTable from "./Editor/Widget_DT";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import WInfo from "./Editor/Widget_Info";
import WButton from "./Editor/Widget_Button";
import WRow from "./Editor/Widget_Row";
import WFilter from "./Editor/Widget_Filter";
import {WREDCapForm} from "./Editor/Widget_REDCapForm";
import WDataElement from "./Editor/Widget_DataElement";
import { Link } from "react-router-dom";
import queryString from 'query-string';
import { logActivity } from "../../services/utilService";
import FormSettings from "./FormSettings";
import ClientSideValidation from "./ClientSideValidation";
import FormCustomCode from "./FormCustomCode";
import WVideo from "./Editor/Widget_Video";
import WMDHData from "./Editor/Widget_MDH_Data";

const validateFilterWidgetAddition = (Form_Widgets,widget) =>{
  const isThereDataTableWidget = Form_Widgets.some(obj =>obj.Widget_Type_ID ===WidgetTypes.DataTable);
  const isFilterWidget = widget.Widget_Type_ID === WidgetTypes.Filter;
  return{
    isThereDataTableWidget,
    isFilterWidget
  }
}
class FormBuilder extends Component {
  Question_types = [];
 

  constructor(props) {
    super(props);
    const queryParameters = queryString.parse(props.location.search);
    const {Form_ID, Form_Name, Project_ID} = queryParameters;
    this.state = {
      Project_ID,
      Form_ID,
      Form_Name,
      Form_Widgets: [],
      Widget_types: [],
      show_order_control: false,
      remove_open: false,
      remove_widget_ID: 0,
      loading: true,
      queryParameters,
      toggleFormSettings: false,
      showFormSettings: false,
      refreshRow: false
    };

    // this.state.Project_ID = this.props.location.Project_ID
    //   ? this.props.location.Project_ID
    //   : 0;
    // this.state.Form_ID = this.props.location.Form_ID
    //   ? this.props.location.Form_ID
    //   : 0;
    // this.state.Form_Name = this.props.location.Form_Name
    //   ? this.props.location.Form_Name
    //   : "";
    this.handleSave = this.handleSave.bind(this);
    this.handleWidgetSelect = this.handleWidgetSelect.bind(this);
    this.handleOrderChange = this.handleOrderChange.bind(this);
    this.confirmRemove = this.confirmRemove.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    const {Form_ID} = this.state;

    const { data: Widget_types } = await getWidgetTypes();
    this.setState({ Widget_types });
    const { data: Form_Widgets } = await getFormWidgets(Form_ID);
        this.setState({ Form_Widgets });

    const { data: qTypes } = await getQuestionTypes();
    this.Question_types = qTypes;

    this.setState({ loading: false });
  }

  handleChange = ({ currentTarget }) => {
    if (currentTarget.name === "Form_Name") {
      let Form_Name = this.state.Form_Name;
      Form_Name = currentTarget.value;
      this.setState({ Form_Name });
    }
  };

  handleRemove = (Widget_ID) => {
        this.setState({ remove_widget_ID: Widget_ID });
    this.setState({ remove_open: true });
  };

  async confirmRemove() {
    const { remove_widget_ID } = this.state;
    const { data } = await removeWidget(remove_widget_ID);
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_DELETE_FAILED');
    } else {
      toaster('success', data);
      logActivity('/formBuilder','WIDGET_DELETE_SUCCESS');
      const Form_Widgets = this.state.Form_Widgets.filter(
        (w) => w.Widget_ID !== remove_widget_ID
      );
      this.setState({ Form_Widgets });
      this.setState({ remove_open: false });
    }
  }

  handleChosen(widget) {
    this.setState({ currentWidget: widget });
  }

  handleShow = () => {
    this.setState({ show_order_control: true });
  };

  handleClose = (name) => {
    this.setState({ [name]: false });
  };

  handleWidgetSelect = async (widget) => {
    const{Form_Widgets:oldForm_Widgets} = this.state;
    const{isThereDataTableWidget,isFilterWidget}= validateFilterWidgetAddition(oldForm_Widgets,widget);
    if (!isThereDataTableWidget && isFilterWidget){
      toaster('error', 'Add a Data Table Widget before adding a Filter Widget');
      return ;
    }
    let invalidWIdentifierCount = ((this.state.Form_Widgets).filter(item => item['Widget_Type_ID'] === 8).length) >= 1
    if (widget['Widget_Type_ID'] === WidgetTypes.Identifier && invalidWIdentifierCount) {
      toaster('error', 'You can add only one Identifier per Form');
      return;
    }
    this.setState({ currentWidget: widget });
    const temp = {
      Widget_ID: -this.state.Form_Widgets.length,
      Widget_Type_ID: widget.Widget_Type_ID,
      Widget_Name: widget.Widget_Type,
    };
    const { data } = await saveFormWidget(
      this.state.Form_ID,
      widget.Widget_Type_ID,
      widget.Widget_Type
    );

    if (data.includes("Success")) {
      temp.Widget_ID = data.split(":").pop();
      toaster('success', 'New widget created');
      logActivity('/formBuilder','WIDGET_CREATE_SUCCESS');
      var Form_Widgets = [...this.state.Form_Widgets, temp];
      this.setState({ Form_Widgets });
      this.handleChosen(temp);
      window.scrollTo({
        top: document.body.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    } else {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_CREATE_FAILED');
    }
  };

  async handleSave() {
    const { data } = await updateForm(this.state.Form_ID, this.state.Form_Name);
    if (data.includes("Success")) {
      if (this.state.Form_ID === 0) {
        const Form_ID = parseInt(data.split(":").pop());
        this.setState({ Form_ID });
      }
      toaster('success', 'Form saved successfully');
      logActivity('/formBuilder','FORM_CREATE_SUCCESS');
    } else {
      toaster('error', 'Error occured in creating form');
      logActivity('/formBuilder','FORM_CREATE_FAILED');
    }
  }

  async handleOrderChange() {
    let Widgets = this.state.Form_Widgets.filter((w) => w.Widget_ID !== 0).map(
      (w, idx) => {
        return { Widget_ID: w.Widget_ID, Display_Order: idx };
      }
    );

    if (Widgets.length !== this.state.Form_Widgets.length) {
      toaster('info', 'Please save all widgets first.');
    } else {
      const { data } = await updateQuestionOrder(Widgets);
      if (data.includes("Error")) {
        toaster('error', data);
        logActivity('/formBuilder','WIDGET_REORDER_FAILED');
      } else {
        toaster('success', data);
        logActivity('/formBuilder','WIDGET_REORDER_SUCCESS');
      }
    }
    this.setState({ show_order_control: false });
  }

  handleMove = (idx, direction) => {
    const widget = this.state.Form_Widgets[idx];
    const Form_Widgets = this.state.Form_Widgets.filter(
      (w) => w.Widget_ID !== widget.Widget_ID
    );
    Form_Widgets.splice(idx + direction, 0, widget);
    this.setState({ Form_Widgets });
  };

  handleShowFormSettings = ()=>{
    // /console.log("toggleFormSettings", this.state.showFormSettings, this.state.toggleFormSettings)
    this.setState({toggleFormSettings: !this.state.toggleFormSettings, showFormSettings: true})
  }

  handleRefreshRowWdiget = () => {
    this.setState({ refreshRow: !this.state.refreshRow})
  }

  render() {
    const { Form_ID, remove_open, Project_ID } = this.state;

    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }
 
    return (
      <React.Fragment>
        <header style={{top: `0px`}} className="page-header page-header-compact page-header-light border-bottom bg-michigan mb-4 nav-sticky">
          <div className="container-fluid">
            <div className="page-header-content">
              <div className="row align-items-center justify-content-between pt-4">
                <div className="col-auto col-xl-6 mb-3">
                  <h1 className="page-header-title text-michigan">
                    <div className="page-header-icon">
                      <Icon.Edit color="#ffcb05" />
                    </div>
                    Form Builder
                    <div className="input-group input-group-joined">
                      <input
                        type="text"
                        className="form-control"
                        name="Form_Name"
                        value={this.state.Form_Name}
                        onChange={this.handleChange}
                        placeholder="Enter form name to start"
                      ></input>
                      {/* Form Settings */}
                      <div className="input-group-append">
                        <button
                          className="btn btn-primary"
                          name='formSettings'
                          onClick={this.handleShowFormSettings}
                        >
                          <Icon.Settings />
                        </button>
                      </div>
                      <div className="input-group-append">
                        <ClientSideValidation Project_ID={this.state.Project_ID} Form_ID={this.state.Form_ID}/>
                      </div>
                      <div className="input-group-append">
                        <FormCustomCode Form_ID={this.state.Form_ID}/>
                      </div>
                      <div className="input-group-append">
                        <button
                          className="btn btn-purple"
                          onClick={this.handleSave}
                        >
                          <Icon.Save />
                        </button>
                      </div>
                    </div>
                  </h1>
                </div>
                <div className="col-6 col-xl-auto mb-3">
                  <Link
                
                    to={`/projectSettings/?Project_ID=${Project_ID}`}
                  >
                    <button className="btn btn-primary rounded-0">
                      Project
                    </button>
                  </Link>

                  <Preview
                    Widgets={this.state.Form_Widgets.filter(
                      (w) => !w.WithinRow
                    )}
                  />
                  <button
                    className="btn btn-primary dropdown-toggle rounded-0"
                    type="button"
                    id="widget_control"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Widget Control
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="widget_control"
                  >
                    <h6 className="dropdown-header">Add</h6>
                    {this.state.Widget_types.map((widget) => {
                      return (
                        <button
                          key={"wType" + widget.Widget_Type_ID}
                          className="dropdown-item"
                          type="button"
                          value={widget.Widget_Type_ID}
                          // disabled={
                          //   widget.Widget_Type_ID === WidgetTypes.Filter
                          // }
                          onClick={() => this.handleWidgetSelect(widget)}
                        >
                          {widget.Widget_Type}
                        </button>
                      );
                    })}
                    <div className="dropdown-divider"></div>
                    <button className="dropdown-item" onClick={this.handleShow}>
                      Change Display Order
                    </button>
                    <FormSettings key={this.state.toggleFormSettings} show={this.state.showFormSettings} Project_ID={Project_ID} Form_ID={Form_ID}/>
                    <Modal
                      size='lg'
                      show={this.state.show_order_control}
                      onHide={() => this.handleClose("show_order_control")}
                    >
                      <Modal.Header closeButton>
                        Change Widget Display Order
                      </Modal.Header>
                      <Modal.Body>
                        <div className="list-group list-group-flush">
                          {
                          this.state.Form_Widgets.map((widget, idx) => {
                            if (!widget.WithinRow) {
                            return (
                              <li
                                className="list-group-item"
                                key={widget.Widget_ID}
                              >
                                {widget.Question_Text && (
                                  <Markup content={widget.Question_Text} />
                                )}
                                {!widget.Question_Text && widget.Widget_Name}
                                <div className="float-right">
                                  {idx !== 0 && (
                                    <span
                                      className="badge badge-light"
                                      onClick={() => this.handleMove(idx, -1)}
                                    >
                                      <FontAwesomeIcon icon={faArrowUp} />
                                    </span>
                                  )}
                                  {idx !==
                                    this.state.Form_Widgets.length - 1 && (
                                    <span
                                      className="badge badge-light"
                                      onClick={() => this.handleMove(idx, 1)}
                                    >
                                      <FontAwesomeIcon icon={faArrowDown} />
                                    </span>
                                  )}
                                </div>
                              </li>
                            );
                            }  
                          })}
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <button
                          className="btn btn-primary"
                          onClick={this.handleOrderChange}
                        >
                          Save
                        </button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <Dialog
          open={remove_open}
          onClose={() => this.handleClose("remove_open")}
          fullWidth
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Please confirm"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure to delete?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <button
              className="btn btn-outline-danger rounded-0 btn-sm"
              onClick={this.confirmRemove}
            >
              Delete
            </button>
            <button
              className="btn btn-outline-primary rounded-0 btn-sm"
              onClick={() => this.handleClose("remove_open")}
              autoFocus
            >
              Cancel
            </button>
          </DialogActions>
        </Dialog>

        {Form_ID !== 0 && (
          <React.Fragment>
            <div className="container">
              {this.state.Form_Widgets.map((widget, idx) => (
                <div
                  key={"Widget" +idx +'-ID' + widget.Widget_ID}
                  className={
                    widget === this.state.currentWidget
                      ? "card border-left-lg border-primary mb-4 px-2"
                      : "card mb-4 px-2"
                  }
                  onClick={() => this.handleChosen(widget, true)}
                >
                  <div className="card-header">
                    <span title={'Display Order: #' + widget.Display_Order}>#{idx + 1} - {widget.Widget_Name} </span>
                    <div className="float-right">
                      {widget.Question_Type_ID && (
                        <select
                          className="select"
                          value={
                            widget.Question_Type_ID === 8
                              ? 2
                              : widget.Question_Type_ID
                          }
                          disabled
                        >
                          <option>Select Question Type</option>
                          {this.Question_types.map((type) => {
                            return (
                              <option
                                key={type.Question_Type_ID}
                                value={type.Question_Type_ID}
                              >
                                {type.Question_Type}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>
                    <span className="float-right px-sm-4">{'Rule ID - #' + widget.Widget_ID}</span>
                  </div>
                  <div className="card-body">
                    {widget.Widget_Type_ID === WidgetTypes.Qualtrics && (
                      <WQualtrics
                        Widget={widget}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                      />
                    )}
                    {widget.Widget_Type_ID === WidgetTypes.REDCapForm && (
                      <WREDCapForm
                        Widget={widget}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                      />
                    )}
                    {widget.Widget_Type_ID === WidgetTypes.QA && (
                      <WQuestionAnswer
                        Widget={widget}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                        Question_Type_ID={widget.Question_Type_ID}
                        refreshRowWidget={this.handleRefreshRowWdiget}
                        Form_Widgets={this.state.Form_Widgets}
                        Form_ID={Form_ID}
                      />
                    )}
                    
                    {widget.Widget_Type_ID === WidgetTypes.Identifier && (
                      <WIdentifier
                        Widget={widget}
                        Project_ID={Project_ID}
                        Form_ID={Form_ID}
                        onRemove={this.handleRemove}
                        Question_Type_ID={widget.Question_Type_ID}
                      />
                    )}
                    {widget.Widget_Type_ID === WidgetTypes.Tabs && (
                      <WTab
                        Widget={widget}
                        Form_ID={Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.DataTable && (
                      <WDataTable
                        Widget={widget}
                        Form_ID={Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.Info && (
                      <WInfo
                        Widget={widget}
                        Widget_Type_ID={widget.Widget_Type_ID}
                        Form_ID={Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                        Widget_Color={widget.Widget_Color}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.Button && (
                      <WButton
                        Widget_ID={widget.Widget_ID}
                        Widget_Type_ID={widget.Widget_Type_ID}
                        Form_ID={Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                        Widget_Color={widget.Widget_Color}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.Randomize && (
                      <WInfo
                        Widget={widget}
                        Widget_Type_ID={widget.Widget_Type_ID}
                        Form_ID={Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                        Widget_Color={widget.Widget_Color}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.Row && (
                      <WRow
                        Widget={widget}
                        Form_ID={Form_ID}
                        onRemove={this.handleRemove}
                        refresh={this.state.refreshRow}
                        refreshRowWidget={this.handleRefreshRowWdiget}
                      />
                    )}
                    {widget.Widget_Type_ID === WidgetTypes.Filter && (
                      <WFilter
                        Widget={widget}
                        Form_ID={Form_ID}
                        onRemove={this.handleRemove}
                        Form_Widgets={this.state.Form_Widgets}
                        Project_ID={Project_ID}
                      />
                    )}

                    {/* Display/Edit Info */}
                    {widget.Widget_Type_ID === WidgetTypes.DisplayEditInfo && (
                      <WDisplayEditInfo
                        Widget={widget}
                        Form_ID={Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.DataElement && (
                      <WDataElement
                        Widget={widget}
                        Form_ID={Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.Video && (
                      <WVideo
                        Widget_ID={widget.Widget_ID}
                        Form_ID={widget.Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                      />
                    )}

                    {widget.Widget_Type_ID === WidgetTypes.MDHData && (
                      <WMDHData
                        Widget_ID={widget.Widget_ID}
                        Form_ID={widget.Form_ID}
                        Project_ID={Project_ID}
                        onRemove={this.handleRemove}
                        Form_Widgets={this.state.Form_Widgets}
                      />
                    )}

                  </div>
                </div>
              ))}
            </div>
          </React.Fragment>
        )}
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default FormBuilder;
